import { useEffect, useState } from 'react';

import { lowerCase } from 'lodash';
import PropTypes from 'prop-types';

import CommunityLinkComponent from './CommunityLinkComponent';

const CommunityLinkContainer = (props) => {
  const {
    onCommunityUpdate,
    onGetCommunityList,
    listParams,
    currentCommunity,
    closeModal,
  } = props;

  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [buildingsList, setBuildingList] = useState([]);
  const [communityName, setCommunityName] = useState(
    currentCommunity?.name ?? '',
  );

  const setInitialCommunityList = async () => {
    try {
      setIsLoading(true);

      const res = await onGetCommunityList({
        ...listParams,
        disable_pagination: true,
        enabled: true,
      });
      const selectedBuildings = currentCommunity?.buildings?.map(
        (building, index) => ({
          ...building,
          isSelected: true,
          isDisabled: index === 0,
        }),
      );

      const selectedBuildingsIds = selectedBuildings?.map(({ id }) => id);

      const buildingOptionsList = res?.data
        ?.map(({ buildings }) => buildings)
        ?.flat()
        ?.filter(({ id }) => !selectedBuildingsIds?.includes(id));
      const buildings = [...selectedBuildings, ...buildingOptionsList];

      setBuildingList(buildings);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setInitialCommunityList();
  }, []);

  const filteredBuildingList = search
    ? buildingsList?.filter(({ name }) =>
        lowerCase(name)?.includes(lowerCase(search)),
      )
    : buildingsList;

  const onLinkCommunities = async () => {
    const newBuildingIds = buildingsList
      ?.filter(({ isSelected }) => isSelected)
      ?.map(({ id }) => id);
    const res = await onCommunityUpdate(currentCommunity, {
      buildings: newBuildingIds,
    });
    res?.data?.id && closeModal();
  };

  const onUpdateCommunityName = async (name) => {
    const res = await onCommunityUpdate(currentCommunity, {
      name,
    });
    res?.data?.id && closeModal();
  };

  return (
    <CommunityLinkComponent
      {...props}
      isLoading={isLoading}
      search={search}
      setSearch={setSearch}
      buildingList={buildingsList}
      filteredBuildingList={filteredBuildingList}
      setBuildingList={setBuildingList}
      onLinkCommunities={onLinkCommunities}
      onUpdateCommunityName={onUpdateCommunityName}
      communityName={communityName}
      setCommunityName={setCommunityName}
    />
  );
};

CommunityLinkContainer.propTypes = {
  onCommunityUpdate: PropTypes.func.isRequired,
  onGetCommunityList: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  currentCommunity: PropTypes.instanceOf(Object).isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default CommunityLinkContainer;
